module.exports = __webpack_public_path__ + "static/img/健康随访@3x.d228e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/健康随访@3x.png
// module id = 305
// module chunks = 363 364